import { GetRequest } from '../../../../../Utils/hooks/ApiHandler'
import { useGetEssentials } from '../../../../../Utils/hooks/useGetEssentials'
import { CEOInvoiceSnap } from "../CEOInvoiceSnap"
import { CEOTodaySnap } from "../CEOTodaySnap"
import { CEOPaymentsSnap } from "../CEOPaymentsSnap"
import { useEffect, useState } from 'react'

export const PaymentInvoices = () => {
    const { headers, extras, customerId } = useGetEssentials()
    const [invoiceData, setInvoiceData] = useState(null)
    const [paymentsData, setPaymentsData] = useState(null)
    const [dailySnaps, setDailySnaps] = useState({})

    const fetchMetadata = async () => {
        try {
            const res = await GetRequest(`dashboard/invoice_payment/${customerId}`, { headers }, extras);
            if (res.status === 'fail' || res.successs === false) {
                return
            }
            const invoices = res.data?.invoices?.length > 0 ? res.data?.invoices : null
            setInvoiceData(invoices)

            const payments = res.data?.payments?.length > 0 ? res.data?.payments : null
            setPaymentsData(payments)

            setDailySnaps({
                dueFollowups: Number(res.data?.followup_due) || 0,
                closedDue: Number(res.data?.deals_closed) || 0,
                projects: Number(res.data?.projects) || 0,
                tickets_raised: 0
            })

        } catch (error) {
            return
        }
    }
    useEffect(() => {
        fetchMetadata()
    }, [])

    return (
        <>
            <CEOInvoiceSnap data={invoiceData} />
            <CEOTodaySnap data={dailySnaps} />
            <CEOPaymentsSnap data={paymentsData} />
        </>
    )
}
